import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, mergeProps as _mergeProps, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex items-center gap-2" }
const _hoisted_2 = { class: "flex flex-col gap-1 py-1 text-left" }
const _hoisted_3 = {
  key: 0,
  class: "opacity-70"
}

import type { FacialBiometrySchedule } from '@/types/facial-biometry.types'


export default /*#__PURE__*/_defineComponent({
  __name: 'ScheduleSummary',
  props: {
    schedules: {},
    align: { default: 'left' },
    dense: { type: Boolean, default: false }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  const _component_v_tooltip = _resolveComponent("v-tooltip")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([
      'flex flex-col gap-0.5',
      _ctx.align === 'center' ? 'items-center overflow-hidden text-center' : ''
    ])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("span", {
        class: _normalizeClass([_ctx.dense ? 'text-[13px]' : 'text-sm', 'text-[#16161d] truncate'])
      }, _toDisplayString(_ctx.schedules[0].name), 3),
      (_ctx.schedules.length > 1)
        ? (_openBlock(), _createBlock(_component_v_tooltip, {
            key: 0,
            location: "top"
          }, {
            activator: _withCtx(({ props: tooltipProps }) => [
              _createElementVNode("span", _mergeProps(tooltipProps, { class: "shrink-0 px-2 py-0.5 rounded border border-[#2f7f91] bg-[#d8eef3] text-[#2f7f91] text-[11px] cursor-default" }), " +" + _toDisplayString(_ctx.schedules.length - 1) + " escalas ", 17)
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.schedules, (schedule) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: schedule.id
                  }, [
                    _createElementVNode("span", null, _toDisplayString(schedule.name), 1),
                    (schedule.healthUnit)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_3, " — " + _toDisplayString(schedule.healthUnit.name), 1))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    (_ctx.schedules[0].healthUnit)
      ? (_openBlock(), _createElementBlock("span", {
          key: 0,
          class: _normalizeClass([_ctx.dense ? 'text-[12px]' : 'text-xs', 'font-bold text-[#16161d] truncate'])
        }, _toDisplayString(_ctx.schedules[0].healthUnit.name), 3))
      : _createCommentVNode("", true)
  ], 2))
}
}

})